import SendIcon from "@mui/icons-material/Send"
import { KeyboardEventHandler, ReactElement } from "react"
import { useForm } from "react-hook-form"

import AppButton from "../../buttons/appButton"
import ValidatedTextField from "../../inputs/validated/validatedTextField"
import { COMMENT_REG } from "../../popUps/dnoResponse/dnoResponseForm"

interface IGenericCreateCommentsComponentProps {
    mutate: () => void
    isLoading: boolean
    createComment: (comment: string) => Promise<void>
}

/**
 * Generic component for adding a comment to a `GenericCommentsCard` component.
 * The functional component should be passed as an argument in `GenericCommentsCard` props
 */
export const GenericCreateCommentsComponent = ({
    mutate,
    isLoading,
    createComment,
}: IGenericCreateCommentsComponentProps): ReactElement => {
    const { control, handleSubmit, watch, reset } = useForm({
        shouldUnregister: true,
    })
    const submitResponse = (): void => {
        const comment = watch(COMMENT_REG)
        createComment(comment)
            .then(() => reset())
            .then(() => mutate())
    }

    const handleKeyPress: KeyboardEventHandler<HTMLDivElement> = (event) => {
        if (event.key === "Enter" && !event.altKey) {
            event.preventDefault()
            submitResponse()
        }
    }

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <ValidatedTextField
                control={control}
                required
                registerName={COMMENT_REG}
                placeholder="Enter a new comment for this device..."
                multiline
                handleKeyPress={handleKeyPress}
            />
            <AppButton
                style={{ alignSelf: "end", marginTop: "8px" }}
                onClick={handleSubmit(submitResponse)}
                disabled={isLoading}
                endIcon={<SendIcon />}
            >
                Add Comment
            </AppButton>
        </div>
    )
}
